import {SET_SEARCH_PARAMS} from "@/store/mutations.type";

export default {
	computed: {
		woodtype: {
			get() {
				return this.$store.state.search.searchParams.woodtype;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {woodtype: value});
			}
		},
		species: {
			get() {
				return this.$store.state.search.searchParams.species;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {species: value});
			}
		},
		logNo: {
			get() {
				return this.$store.state.search.searchParams.logNo;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {logNo: value});
			}
		},
		palletNo: {
			get() {
				return this.$store.state.search.searchParams.palletNo;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {palletNo: value});
			}
		},
		thickness: {
			get() {
				return this.$store.state.search.searchParams.thickness;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {thickness: value});
			}
		},
		characteristic: {
			get() {
				return this.$store.state.search.searchParams.characteristic || null;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {characteristic: value});
			}
		},
		qualities: {
			get() {
				return this.$store.state.search.searchParams.qualities;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {qualities: value});
			}
		},
		structure: {
			get() {
				return this.$store.state.search.searchParams.structure || null;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {structure: value});
			}
		},
		lengthFrom: {
			get() {
				return this.$store.state.search.searchParams.lengthFrom;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {lengthFrom: value});
			}
		},
		lengthMax: {
			get() {
				return this.$store.state.search.searchParams.lengthMax;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {lengthMax: value});
			}
		},
		widthFrom: {
			get() {
				return this.$store.state.search.searchParams.widthFrom;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {widthFrom: value});
			}
		},
		widthTo: {
			get() {
				return this.$store.state.search.searchParams.widthTo;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {widthTo: value});
			}
		},
		areaFrom: {
			get() {
				return this.$store.state.search.searchParams.areaFrom;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {areaFrom: value});
			}
		},
		areaTo: {
			get() {
				return this.$store.state.search.searchParams.areaTo;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {areaTo: value});
			}
		},
		gradeFrom: {
			get() {
				return this.$store.state.search.searchParams.gradeFrom;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {gradeFrom: value});
			}
		},
		gradeTo: {
			get() {
				return this.$store.state.search.searchParams.gradeTo;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {gradeTo: value});
			}
		},
		internalQuality: {
			get() {
				return this.$store.state.search.searchParams.internalQuality;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {internalQuality: value});
			}
		},
		info: {
			get() {
				return this.$store.state.search.searchParams.info;
			},
			set(value) {
				this.$store.commit(SET_SEARCH_PARAMS, {info: value});
			}
		}
	}
}